module.exports = __webpack_public_path__ + "img/icon-play.c065caa7.svg";